export default __webpack_public_path__ + "static/media/gallery_05.98bf80a5.jpg";